import React, { useContext } from 'react';

import { CreateForm, Form } from './types';
import useForm from './useForm';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FormContext = React.createContext<Form<any, any, any, any> | undefined>(undefined);

export const useFormContext = <T, A, E, AT = unknown>() => {
    const context = useContext<Form<T, A, E, AT> | undefined>(FormContext)!;
    if (context === undefined) {
        throw new Error('useFormContext must be used within FormContextProvider');
    }

    return context;
};

export const FormContextProvider = <T, A, E extends object, AT = unknown>({
    validateHook,
    reducer,
    initialState,
    children,
}: CreateForm<T, A, E>) => {
    const form = useForm<T, A, E, AT>(validateHook, reducer, initialState);
    return <FormContext.Provider value={form}>{children}</FormContext.Provider>;
};

export default FormContext;
